import instance from './common';

function getDimensions({ context = '' }) {
  const route = context ? `/dimensions-list?context=${context}` : '/dimensions-list';
  return instance.get(route);
}

function getDimensionData(reqBody, options = {}, http = instance) {
  // Below is the correct way to add traceparent header to the request and capture the span data
  // We are not using this as of now but keeping this as a reference.
  // We are ending the span here after receiving the response, thus giving accurate interval.
  /*
    const dimensionSpan = trace.getTracer('default').startSpan('dimension');
    console.log('Dimension Span', dimensionSpan);
    dimensionSpan.addEvent("Metric Span")
    const key = createContextKey(`HTTP POST dimension context`);
    const ctx = context.active();
    context.with(ctx.setValue(key, dimensionSpan), () => {
      const spanid = dimensionSpan.spanContext().spanId;
      const traceid = dimensionSpan.spanContext().traceId;
      if(!options['headers']) {
        options['headers'] = {};
      }
      options['headers']['traceparent'] = "00-" + traceid + "-" + spanid + "-" + "00";
      options['headers']['trace-id'] = dimensionSpan.spanContext().traceId;
    });
    const response = http.post('/metrics', reqBody, options);
    dimensionSpan.end();
    return response;
  */
  return http.post('/metrics', reqBody, options);
}

export { getDimensions, getDimensionData };
